import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";
import { cn } from "../../lib/utils";

// Sprint 38 — Contractual Precision: default 1.5px subtle divider.
// For 3px section rules, use the .rule-3 utility class on the parent
// or set className="h-[3px] bg-border" directly.
const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    weight?: "subtle" | "default" | "section";
  }
>(
  (
    { className, orientation = "horizontal", decorative = true, weight = "subtle", ...props },
    ref,
  ) => {
    const thickness =
      weight === "section"
        ? orientation === "horizontal" ? "h-[3px]" : "w-[3px]"
        : weight === "default"
        ? orientation === "horizontal" ? "h-[2px]" : "w-[2px]"
        : orientation === "horizontal" ? "h-[1.5px]" : "w-[1.5px]";

    const color = weight === "subtle" ? "bg-border-subtle" : "bg-border";

    return (
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          "shrink-0",
          color,
          orientation === "horizontal" ? `${thickness} w-full` : `${thickness} h-full`,
          className,
        )}
        {...props}
      />
    );
  },
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
